<template>
    <CampaignCouponDiscountForm />
</template>

<script>
import CampaignCouponDiscountForm from "@/components/CampaignCouponDiscountForm.vue";

export default {
    name: "CampaignCouponDiscountFormView",
    components: {
        CampaignCouponDiscountForm,
    },
};
</script>